module.exports = __webpack_public_path__ + "img/logo.d413d1d5.svg";